import { render, staticRenderFns } from "./MultiSelector.vue?vue&type=template&id=0ca047a9&scoped=true"
import script from "./MultiSelector.vue?vue&type=script&lang=js"
export * from "./MultiSelector.vue?vue&type=script&lang=js"
import style0 from "./MultiSelector.vue?vue&type=style&index=0&id=0ca047a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca047a9",
  null
  
)

export default component.exports